import debounce from 'lodash/debounce'
import React, { useCallback, useEffect, useState } from 'react'

import { SearchInput, SearchInputProps, useIsTabletOrMobile } from '@avantstay/backoffice-core'

interface SearchFilterProps extends Partial<Omit<SearchInputProps, 'onChange'>> {
  initialValue?: string
  onChange: (value?: string) => void
}

const DEFAULT_INPUT_WIDTH = 280
const DEFAULT_MOBILE_INPUT_WIDTH = 100

export const SearchFilter = ({
  initialValue,
  onChange,
  placeholder = 'Search',
  width,
  ...searchInputProps
}: SearchFilterProps) => {
  const isTabletOrMobile = useIsTabletOrMobile()

  const [localValue, setLocalValue] = useState<string | undefined>(initialValue)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedInputOnChange = useCallback(
    debounce((value?: string) => {
      onChange(value)
    }, 300),
    [],
  )

  useEffect(() => {
    if (localValue !== initialValue) {
      debouncedInputOnChange(localValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localValue])

  // This clears selection when we run propertiesListStore.resetFilters
  useEffect(() => {
    if (initialValue === undefined || initialValue === '') {
      setLocalValue('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue])

  const defaultInputWidth = isTabletOrMobile ? DEFAULT_MOBILE_INPUT_WIDTH : DEFAULT_INPUT_WIDTH

  return (
    <SearchInput
      onChange={value => setLocalValue(value)}
      placeholder={placeholder}
      searchTerm={localValue}
      width={width || defaultInputWidth}
      {...searchInputProps}
    />
  )
}
